function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "token / dark / snx");

var _ref3 = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.");

var _ref4 = /*#__PURE__*/React.createElement("g", {
  id: "dashboard",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "organisms-/-lightMode-/-dashboard-/-prices",
  transform: "translate(-32.000000, -78.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "SNX",
  transform: "translate(32.000000, 78.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "token-/-dark-/-snx"
}, /*#__PURE__*/React.createElement("circle", {
  id: "Oval",
  fill: "#1E1A31",
  cx: 20,
  cy: 20,
  r: 20
}), /*#__PURE__*/React.createElement("g", {
  id: "logo-/-icon-/-snx-/-snx-light",
  transform: "translate(13.466667, 11.333333)",
  fill: "#FFFFFF"
}, /*#__PURE__*/React.createElement("polygon", {
  id: "Stroke",
  opacity: 0.5,
  points: "2.1567246 16.1537174 0.517474803 14.9890831 10.82772 0.722948196 12.4669698 1.88758252"
}), /*#__PURE__*/React.createElement("path", {
  d: "M7.46752931,7.49954809 L8.01790175,7.49954809 C10.5518719,7.49954809 12.6060606,9.53847563 12.6060606,12.0536202 C12.6060606,14.5687648 10.5518719,16.6076923 8.01790175,16.6076923 L1.27056661,16.6076923 C0.713896582,16.6076923 0.262626263,16.1597747 0.262626263,15.6072404 C0.262626263,15.054706 0.713896582,14.6067884 1.27056661,14.6067884 L8.01790175,14.6067884 C9.43853187,14.6067884 10.5901801,13.4636961 10.5901801,12.0536202 C10.5901801,10.6435443 9.43853187,9.500452 8.01790175,9.500452 L5.40158813,9.500452 L5.40115756,9.50045191 L4.85078512,9.50045191 C2.31681496,9.50045191 0.262626263,7.46152436 0.262626263,4.94637978 C0.262626263,2.43123522 2.31681496,0.392307692 4.85078512,0.392307692 L11.5981203,0.392307692 C12.1547903,0.392307692 12.6060606,0.840225289 12.6060606,1.39275965 C12.6060606,1.945294 12.1547903,2.3932116 11.5981203,2.3932116 L4.85078512,2.3932116 C3.430155,2.3932116 2.27850673,3.53630394 2.27850673,4.94637978 C2.27850673,6.35645565 3.430155,7.499548 4.85078512,7.499548 L7.46709874,7.499548 C7.46724227,7.499548 7.46738579,7.49954803 7.46752931,7.49954809 L7.46752931,7.49954809 Z",
  id: "Path"
}))))));

var SvgSnx = function SvgSnx(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "40px",
    height: "40px",
    viewBox: "0 0 40 40",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSnx, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/SNX.820c365e.svg";
export { ForwardRef as ReactComponent };